module.exports = __webpack_public_path__ + "img/loisir2.a14c291e.jpg";